// extracted by mini-css-extract-plugin
export default {"new-measure":"_new-measure_Tp-e8n"};